import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=5258cf8f"
import script from "./Documents.vue?vue&type=script&lang=js"
export * from "./Documents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5258cf8f')) {
      api.createRecord('5258cf8f', component.options)
    } else {
      api.reload('5258cf8f', component.options)
    }
    module.hot.accept("./Documents.vue?vue&type=template&id=5258cf8f", function () {
      api.rerender('5258cf8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/profile/Documents.vue"
export default component.exports